const acronyms = ['url', 'tz', 'id']; // todo

const snakeToCamel = (str) => {
  return str.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase());
};

const flattenAcronyms = (str = '') => {
  return str
    .replace(/([A-Z]+)([A-Z][a-z])/g, (match, p1, p2) => {
      return p1.length > 1 ? p1.charAt(0) + p1.slice(1).toLowerCase() + p2 : match;
    })
    .replace(/([a-z])([A-Z]+)/g, (match, p1, p2) => {
      return p2.length > 1 ? p1 + p2.charAt(0).toUpperCase() + p2.slice(1).toLowerCase() : match;
    });
};

export const camelToTitle = (str) => {
  if (str === null || str === undefined) {
    return '';
  }

  let input = str;
  if (typeof input === 'object') {
    if (input instanceof Date) {
      input = String(input);
    } else {
      return '';
    }
  } else if (typeof input !== 'string') {
    input = String(input);
  }

  // Convert snake_case to camelCase first if underscores are present
  const camelCased = input.includes('_') ? snakeToCamel(input) : input;

  const flat = flattenAcronyms(camelCased);
  const result = flat.replace(/([A-Z])/g, ' $1');
  const parts = (result.charAt(0).toUpperCase() + result.slice(1)).split(' ');
  return parts.map((n) => (acronyms.includes(n?.toLowerCase()) ? n.toUpperCase() : n)).join(' ');
};
